import React from "react";

const SmallGreenCircle = () => (
  <svg
    width="328"
    height="328"
    viewBox="0 0 328 328"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="164" cy="164" r="148.5" stroke="#0BC76D" strokeWidth="31" />
  </svg>
);

export default SmallGreenCircle;
